export const EVENT_REGISTRATION_FIELD_TYPES = [
  { value: "text", label: "Text" },
  { value: "phone", label: "Phone number" },
  { value: "email", label: "Email" },
  { value: "image", label: "Image upload" },
];

export const COMMON_EVENT_REGISTRATION_FIELDS = [
  { id: "full-name", label: "Full name", kind: "text", required: true },
  { id: "phone-number", label: "Phone number", kind: "phone", required: true },
  { id: "email-address", label: "Email address", kind: "email", required: false },
  { id: "payment-screenshot", label: "Payment screenshot", kind: "image", required: false },
];

// RSVP-oriented preset for personal events (weddings, birthdays, etc.).
export const RSVP_REGISTRATION_FIELDS = [
  { id: "guest-name", label: "Your name", kind: "text", required: true },
  { id: "phone-number", label: "Phone number", kind: "phone", required: false },
  { id: "guest-count", label: "Number of guests", kind: "text", required: false },
  { id: "attendance", label: "Will you attend? (Yes / No)", kind: "text", required: true },
];

export function createRegistrationField(overrides = {}) {
  const seed = overrides.label || overrides.id || "field";
  return {
    id: slugifyFieldId(seed),
    label: "Custom field",
    kind: "text",
    required: false,
    ...overrides,
  };
}

export function normalizeRegistrationFields(fields = []) {
  return fields
    .map((field, index) => createRegistrationField({
      ...field,
      id: slugifyFieldId(field?.id || field?.label || `field-${index + 1}`),
      label: (field?.label || `Field ${index + 1}`).trim(),
    }))
    .filter((field) => field.label);
}

function slugifyFieldId(value = "") {
  return value
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "") || `field-${Math.random().toString(36).slice(2, 8)}`;
}
